/* ============================================================
   SOLITARY KILLS — theme.js
   Cart drawer, variant selection, accordion, qty steppers,
   grid toggle, availability filter, mobile nav. No dependencies.
   ============================================================ */
(function () {
  'use strict';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var money = function (cents) { return '$' + (cents / 100).toFixed(2); };

  /* ---------- mobile nav ---------- */
  $$('.sk-menu-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var nav = btn.closest('.sk-header').querySelector('.sk-mobile-nav');
      if (nav) nav.classList.toggle('open');
    });
  });

  /* ---------- cart drawer ---------- */
  var drawer = $('#sk-cart-drawer');
  var veil = $('#sk-drawer-veil');

  function openDrawer() {
    if (!drawer) return;
    refreshCart().then(function () {
      drawer.classList.add('open');
      if (veil) veil.classList.add('open');
      document.body.style.overflow = 'hidden';
    });
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('open');
    if (veil) veil.classList.remove('open');
    document.body.style.overflow = '';
  }
  $$('[data-open-cart]').forEach(function (el) {
    el.addEventListener('click', function (e) { e.preventDefault(); openDrawer(); });
  });
  var closeBtn = $('.sk-drawer__close');
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  if (veil) veil.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  function refreshCart() {
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      renderCart(cart);
      updateCounts(cart);
    }).catch(function () {});
  }

  function updateCounts(cart) {
    $$('.sk-cart-count').forEach(function (el) {
      el.textContent = cart.item_count;
      el.style.display = cart.item_count > 0 ? 'flex' : 'none';
    });
  }

  function renderCart(cart) {
    var box = $('#sk-drawer-items');
    var foot = $('#sk-drawer-foot');
    if (!box) return;
    if (!cart.items.length) {
      box.innerHTML = '<div class="sk-drawer__empty"><p>Cart is empty</p><span>Nothing here yet. Go get something.</span></div>';
      if (foot) foot.style.display = 'none';
      return;
    }
    if (foot) foot.style.display = '';
    box.innerHTML = cart.items.map(function (it) {
      return '<div class="sk-ci" data-key="' + it.key + '">' +
        '<img src="' + it.image.replace(/(\.[a-z]+)(\?.*)?$/, '_200x$1') + '" alt="">' +
        '<div class="sk-ci__info">' +
          '<div class="sk-ci__title">' + it.product_title + '</div>' +
          '<div class="sk-ci__variant">' + (it.variant_title || '') + '</div>' +
          '<div class="sk-ci__row">' +
            '<div class="sk-ci__qty">' +
              '<button data-dec aria-label="Decrease">−</button><span>' + it.quantity + '</span><button data-inc aria-label="Increase">+</button>' +
            '</div>' +
            '<div class="sk-ci__price">' + money(it.line_price) + '</div>' +
          '</div>' +
          '<button class="sk-ci__remove" data-remove>Remove</button>' +
        '</div></div>';
    }).join('');
    var sub = $('#sk-drawer-subtotal');
    if (sub) sub.textContent = money(cart.total_price);

    $$('#sk-drawer-items [data-inc]').forEach(function (b) {
      b.addEventListener('click', function () { changeQty(b, 1); });
    });
    $$('#sk-drawer-items [data-dec]').forEach(function (b) {
      b.addEventListener('click', function () { changeQty(b, -1); });
    });
    $$('#sk-drawer-items [data-remove]').forEach(function (b) {
      b.addEventListener('click', function () {
        var key = b.closest('.sk-ci').getAttribute('data-key');
        setQty(key, 0);
      });
    });
  }

  function changeQty(btn, delta) {
    var row = btn.closest('.sk-ci');
    var key = row.getAttribute('data-key');
    var qty = parseInt(row.querySelector('.sk-ci__qty span').textContent, 10) + delta;
    setQty(key, Math.max(qty, 0));
  }
  function setQty(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(function (cart) {
      renderCart(cart); updateCounts(cart);
    }).catch(function () {});
  }

  /* ---------- product form: variants, qty, add to cart ---------- */
  var form = $('#sk-product-form');
  if (form) {
    var variantInput = $('#sk-variant-id', form);
    var priceEl = $('#sk-product-price');
    var compareEl = $('#sk-product-compare');
    var addBtn = $('#sk-add-btn');
    var variants = [];
    try { variants = JSON.parse($('#sk-variant-data').textContent); } catch (e) {}

    function selectVariant(id) {
      var v = variants.filter(function (x) { return x.id === id; })[0];
      if (!v) return;
      variantInput.value = v.id;
      $$('.sk-variant', form).forEach(function (b) {
        b.classList.toggle('is-selected', b.getAttribute('data-variant-id') === String(v.id));
      });
      if (priceEl) priceEl.textContent = money(v.price);
      if (compareEl) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          compareEl.textContent = money(v.compare_at_price);
          compareEl.style.display = '';
        } else { compareEl.style.display = 'none'; }
      }
      if (addBtn) {
        if (v.available) {
          addBtn.disabled = false;
          addBtn.querySelector('span').textContent = 'Add to cart';
        } else {
          addBtn.disabled = true;
          addBtn.querySelector('span').textContent = 'Sold out';
        }
      }
      /* keep the sticky buy bar in sync */
      var stickyPrice = $('#sk-sticky-price');
      var stickyAdd = $('#sk-sticky-add');
      if (stickyPrice) stickyPrice.textContent = money(v.price);
      if (stickyAdd) {
        stickyAdd.disabled = !v.available;
        stickyAdd.querySelector('span').textContent = v.available ? 'Add to cart' : 'Sold out';
      }
      var media = document.querySelector('.sk-product__gallery img[data-media-id="' + v.featured_media_id + '"]');
      if (media) media.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    $$('.sk-variant', form).forEach(function (b) {
      if (b.classList.contains('is-unavailable')) return;
      b.addEventListener('click', function () { selectVariant(parseInt(b.getAttribute('data-variant-id'), 10)); });
    });

    /* qty stepper */
    var qtyInput = $('#sk-qty-input');
    $$('[data-qty-plus]').forEach(function (b) {
      b.addEventListener('click', function () { qtyInput.value = parseInt(qtyInput.value, 10) + 1; });
    });
    $$('[data-qty-minus]').forEach(function (b) {
      b.addEventListener('click', function () {
        qtyInput.value = Math.max(1, parseInt(qtyInput.value, 10) - 1);
      });
    });

    /* ajax add */
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (addBtn.disabled) return;
      addBtn.disabled = true;
      addBtn.querySelector('span').textContent = 'Adding…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantInput.value, quantity: parseInt(qtyInput.value, 10) || 1 })
      }).then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      }).then(function () {
        addBtn.disabled = false;
        var v = variants.filter(function (x) { return String(x.id) === variantInput.value; })[0];
        addBtn.querySelector('span').textContent = (v && v.available) ? 'Add to cart' : 'Sold out';
        openDrawer();
      }).catch(function () {
        addBtn.disabled = false;
        addBtn.querySelector('span').textContent = 'Add to cart';
      });
    });

    /* sticky buy bar: tap = same as the main add button */
    var stickyAddBtn = $('#sk-sticky-add');
    if (stickyAddBtn && addBtn) {
      stickyAddBtn.addEventListener('click', function () { addBtn.click(); });
    }
  }

  /* ---------- product gallery dots (mobile carousel) ---------- */
  var gallery = $('.sk-product__gallery');
  if (gallery && window.matchMedia('(max-width: 768px)').matches) {
    var gImgs = $$('img', gallery);
    if (gImgs.length > 1) {
      var dots = document.createElement('div');
      dots.className = 'sk-gallery-dots';
      gImgs.forEach(function (_, i) {
        var d = document.createElement('span');
        if (i === 0) d.className = 'is-active';
        dots.appendChild(d);
      });
      gallery.parentNode.insertBefore(dots, gallery.nextSibling);
      gallery.addEventListener('scroll', function () {
        var idx = Math.round(gallery.scrollLeft / gallery.clientWidth);
        $$('span', dots).forEach(function (d, i) {
          d.classList.toggle('is-active', i === idx);
        });
      }, { passive: true });
    }
  }

  /* ---------- quick add (product cards) ---------- */
  function quickAdd(id, btn) {
    if (btn) btn.classList.add('is-adding');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: id, quantity: 1 })
    }).then(function (r) {
      if (!r.ok) throw new Error('quick add failed');
      return r.json();
    }).then(function () {
      if (btn) btn.classList.remove('is-adding');
      $$('.sk-card__sheet').forEach(function (s) { s.hidden = true; });
      openDrawer();
    }).catch(function () {
      if (btn) btn.classList.remove('is-adding');
    });
  }
  $$('[data-quickadd]').forEach(function (b) {
    b.addEventListener('click', function (e) {
      e.preventDefault();
      if (b.disabled) return;
      quickAdd(b.getAttribute('data-variant-id'), b);
    });
  });
  $$('[data-quickadd-toggle]').forEach(function (b) {
    b.addEventListener('click', function (e) {
      e.preventDefault();
      var card = b.closest('.sk-card');
      var sheet = card ? $('.sk-card__sheet', card) : null;
      if (!sheet) return;
      var willOpen = sheet.hidden;
      $$('.sk-card__sheet').forEach(function (s) { s.hidden = true; });
      sheet.hidden = !willOpen;
    });
  });
  $$('[data-sheet-close]').forEach(function (b) {
    b.addEventListener('click', function (e) {
      e.preventDefault();
      var sheet = b.closest('.sk-card__sheet');
      if (sheet) sheet.hidden = true;
    });
  });

  /* ---------- FAQ accordion ---------- */
  $$('.sk-faq__q').forEach(function (q) {
    q.addEventListener('click', function () {
      var item = q.closest('.sk-faq__item');
      var ans = item.querySelector('.sk-faq__a');
      var isOpen = item.classList.contains('open');
      $$('.sk-faq__item.open').forEach(function (o) {
        o.classList.remove('open');
        o.querySelector('.sk-faq__a').style.maxHeight = '0px';
        o.querySelector('.sk-faq__q').setAttribute('aria-expanded', 'false');
      });
      if (!isOpen) {
        item.classList.add('open');
        ans.style.maxHeight = ans.scrollHeight + 'px';
        q.setAttribute('aria-expanded', 'true');
      }
    });
  });

  /* ---------- collection: grid toggle ---------- */
  var grid = $('#sk-collection-grid');
  $$('.sk-gridtoggle button').forEach(function (b) {
    b.addEventListener('click', function () {
      $$('.sk-gridtoggle button').forEach(function (x) { x.classList.remove('is-active'); });
      b.classList.add('is-active');
      if (grid) grid.classList.toggle('sk-grid--2', b.getAttribute('data-cols') === '2');
    });
  });

  /* ---------- collection: availability filter (client-side) ---------- */
  var availBox = $('#sk-avail-toggle');
  if (availBox && grid) {
    availBox.addEventListener('change', function () {
      $$('.sk-card', grid).forEach(function (card) {
        var soldout = card.getAttribute('data-soldout') === 'true';
        card.style.display = (availBox.checked && soldout) ? 'none' : '';
      });
    });
  }

  /* ---------- collection: sort (native reload) ---------- */
  var sortSel = $('#sk-sort');
  if (sortSel) {
    sortSel.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSel.value);
      window.location.href = url.toString();
    });
  }

  /* ---------- marquee: duplicate content for seamless loop ---------- */
  $$('.sk-marquee__track').forEach(function (t) {
    t.innerHTML += t.innerHTML;
  });
})();
